import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const timelineDefaultVariants = {}
const timelineCompoundVariants = []

const timelineSlotNames = [
  [
    "root",
    "timeline__root"
  ],
  [
    "track",
    "timeline__track"
  ],
  [
    "progress",
    "timeline__progress"
  ],
  [
    "marker",
    "timeline__marker"
  ],
  [
    "labels",
    "timeline__labels"
  ]
]
const timelineSlotFns = /* @__PURE__ */ timelineSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, timelineDefaultVariants, getSlotCompoundVariant(timelineCompoundVariants, slotName))])

const timelineFn = memo((props = {}) => {
  return Object.fromEntries(timelineSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const timelineVariantKeys = []
const getVariantProps = (variants) => ({ ...timelineDefaultVariants, ...compact(variants) })

export const timeline = /* @__PURE__ */ Object.assign(timelineFn, {
  __recipe__: false,
  __name__: 'timeline',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: timelineVariantKeys,
  variantMap: {},
  splitVariantProps(props) {
    return splitProps(props, timelineVariantKeys)
  },
  getVariantProps
})